import * as React from 'react';
import {useEffect, useState} from 'react';
import {BasicCandidateCard} from "./BasicCandidateCard";
import { Button } from 'antd';
import { ApplyReaction } from '../Modals/ApplyReaction';
import { DenyReaction } from '../Modals/DenyReaction';
import { ReactionStatus } from '../../Enums/ReactionStatus';
import { Candidate, Reaction } from '../../types';

type ReactionCandidateCardProps = {
    candidate: Candidate,
    isView?: boolean,
    reaction: Reaction
};

export function ReactionCandidateCard({ candidate, isView, reaction }: ReactionCandidateCardProps) {
    const [isApplyOpen, setIsApplyOpen] = useState(false);
    const [isDenyOpen, setIsDenyOpen] = useState(false);
    const [reactionStatus, setReactionStatus] = useState(reaction.status)
    
    const showModalApply = async (e: MouseEvent) => {
        e.preventDefault();
        if (reactionStatus === ReactionStatus.NotView || reactionStatus === ReactionStatus.View) {
            setIsApplyOpen(true);
        }
    };

    const closeModalApply = () => setIsApplyOpen(false);

    const showModalDeny = async (e: MouseEvent) => {
        e.preventDefault();
        if (reactionStatus === ReactionStatus.NotView || reactionStatus === ReactionStatus.View) {
            setIsDenyOpen(true);
        }
    };

    const closeModalDeny = () => setIsDenyOpen(false);

    useEffect(() => {
        setReactionStatus(reaction.status)
    }, [reaction])

    return (
        <>
            <BasicCandidateCard candidate={candidate} isView={isView} link={'/reaction/'+reaction.id} >
                {(reactionStatus === ReactionStatus.NotView || reactionStatus === ReactionStatus.View) && 
                <>
                    <Button 
                        type="primary" 
                        style={{height:'32px', padding: '5px 16px', marginRight: '16px'}}
                        onClick={() => showModalApply}> 
                        Пригласить 
                    </Button>
                    <Button 
                        danger 
                        style={{height:'32px', padding: '5px 16px'}}
                        onClick={() => showModalDeny} > 
                        Отказать 
                    </Button>
                </>}
                {(reactionStatus === ReactionStatus.Invitation || reactionStatus === ReactionStatus.SentToStudent) && 
                    <button className="green-button" style={{height:'32px', padding: '5px 16px', marginRight: '16px'}}> Приглашение отправлено </button>
                }
                {(reactionStatus === ReactionStatus.StudentAccepted) && 
                    <button className="green-button" style={{height:'32px', padding: '5px 16px', marginRight: '16px'}}> Приглашение принято </button>
                }
                {(reactionStatus === ReactionStatus.Reject || reactionStatus === ReactionStatus.StudentRejected) && 
                    <button className="red-button" style={{height:'32px', padding: '5px 16px', marginRight: '16px'}}> Отказано </button>
                }
            </BasicCandidateCard>
            <ApplyReaction isOpen={isApplyOpen} close={closeModalApply} reactionId={reaction.id} setStatus={setReactionStatus}/>
            <DenyReaction isOpen={isDenyOpen} close={closeModalDeny} reactionId={reaction.id} setStatus={setReactionStatus}/>
        </>
    )
}